var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#e94619",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0.00213) scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.876,2.672c-0.58833,-1.03394 -1.68639,-1.67251 -2.876,-1.67251c-1.18961,0 -2.28767,0.63856 -2.876,1.67251l-8.71,15.518c-0.563,0.99126 -0.55193,2.20814 0.029,3.189c0.58947,1.01196 1.67591,1.63055 2.847,1.621h17.42c1.17109,0.00955 2.25753,-0.60904 2.847,-1.621c0.58093,-0.98086 0.592,-2.19774 0.029,-3.189zM21.831,20.372c-0.23437,0.39485 -0.66188,0.63434 -1.121,0.628h-17.42c-0.45974,0.00572 -0.88739,-0.235 -1.121,-0.631c-0.22155,-0.36826 -0.22576,-0.82774 -0.011,-1.2l8.71,-15.519c0.25061,-0.38094 0.67602,-0.61028 1.132,-0.61028c0.45598,0 0.88139,0.22935 1.132,0.61028l8.71,15.518c0.21515,0.37251 0.21094,0.8325 -0.011,1.201z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,7c-0.55228,0 -1,0.44772 -1,1v6c0,0.55228 0.44772,1 1,1c0.55228,0 1,-0.44772 1,-1v-6c0,-0.55228 -0.44772,-1 -1,-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.7b4c354166379631d46b344931f80992.svg";
export { ForwardRef as ReactComponent };